const navigationButtonsOptions = {
  navigation: {
    nextEl: ".slider-next",
    prevEl: ".slider-prev",
  },
  on: {
    init: (s) => {
      s.el.querySelector(".slider-prev").classList.add("hidden");
    },
    activeIndexChange: (s) => {
      console.log(s);
      if (s.activeIndex === 0)
        s.el.querySelector(".slider-prev").classList.add("hidden");
      else s.el.querySelector(".slider-prev").classList.remove("hidden");
      if (s.isEnd) s.el.querySelector(".slider-next").classList.add("hidden");
      else s.el.querySelector(".slider-next").classList.remove("hidden");
    },
  },
};

const bestSellersSlider = new Swiper("#best-sellers__slider", {
  slidesPerView: 4,
  spaceBetween: 24,
  initialSlide: 0,
  ...navigationButtonsOptions,
});

const newInSlider = new Swiper("#new-in__slider", {
  slidesPerView: "auto",
  spaceBetween: 24,
  navigation: {
    nextEl: ".slider-next",
    prevEl: ".slider-prev",
  },
  ...navigationButtonsOptions,
});

$(document).ready(function() { 
$(".color-selector__option").click(function(){
    var urll = $(this).attr("url");
  console.log(urll);
 window.top.location = urll;
 
//   jQuery.ajax({
//     type: 'GET',
//     url: urll,
//     success: function(response) {
//       setTimeout(function(){
//         var newhtml = $(response).find('.product__images').html();
//       $('.product__images').html(newhtml);
//       var color_text = $(response).find('.color-selector__variant-title').html();
//       $('.color-selector').find('.color-selector__variant-title').html(color_text);
//       var color_image = $(response).find('.color-selector__image').html();
//       $('.color-selector').find('.color-selector__image').html(color_image);
//       var product_form = $(response).find('.product__form').html();
//       $('.product__form').html(product_form);
//       },2000);
//     },
//     error: function(error) {
//         console.log("Error: "+ error);
//     }
// });
});
  
 
});  
